// import axios from "axios"
// import {REACT_APP_BACKEND_SERVER_URL} from "../config/index"
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// export const transform_text = (num) => {
//   if (num === undefined || num === null) return "";
//   // Force convert to string always
//   const str = String(num);
//   // If "__" not found, return whole string
//   if (!str.includes("__")) return str;
//   return str.split("__")[0];
// };

// // export const handleWeight = async () => {
// //     try {
// //       const res = await axios.get(`${REACT_APP_BACKEND_SERVER_URL}/api/v1/weight/getWeight`);
// //       return res.data;  // Ensure the function returns the weight data
// //     } catch (err) {
// //       toast.warn("weight mechine not Connected",{autoClose:2000})
// //       // console.log(err.message);
// //       return null;  // Return null if there's an error
// //     }
// //   };
// // this is web socket Port for get weight form this port


// const ws = new WebSocket("wss://wss1_ibacus.octosignals.com/ws/stream");

// export const handleWeight = () => {
//   return new Promise((resolve, reject) => {

//     if (ws.readyState !== WebSocket.OPEN) {
//       return reject("Weight machine not connected");
//     }

//     ws.onmessage = (event) => {
//       const data = JSON.parse(event.data);
//       console.log('weight Data',data)
//       resolve(data.weight);
//     };

//     ws.onerror = () => reject("Error receiving weight");
//   });
// };


  
//   export const weightVerify = (value, weight1, weight2) => {
//     // Check for the initial invalid condition
//     if (!weight1 || !weight2 || isNaN(weight1) || isNaN(weight2)) {
//           alert("Please Enter the Value")
//         return;
//     }

//     // Convert to number if they are strings
//     weight1 = parseFloat(weight1);
//     weight2 = parseFloat(weight2);

//     // Calculate weight difference
//     const weight = (weight1 - weight2).toFixed(3);
//     const diffValue = parseFloat(weight);

//     // Check if the difference is positive within range
//     if (diffValue >= 0.000 && diffValue <= 0.100) {
//         alert(`Verify Success on ${value} weight difference`);
//     }
//     // Check if the difference is negative within range
//     else if (diffValue < 0.000 && diffValue >= -0.100) {
//         alert(`Verify Success on ${value} weight difference`);
//     }
//     // Check if the difference is greater than positive range
//     else if (diffValue > 0.100) {
//         window.confirm(`Difference ${diffValue} exceeds the upper limit. Verify failed on ${value} weight difference. Correct Range >= 0.000 to <= 0.100. Do you want to continue?`);
//     }
//     // All other cases (negative difference exceeds range)
//     else {
//         window.confirm(`Difference ${diffValue} is below the lower limit. Verify failed on ${value} weight difference. Correct Range -0.100 to <= 0.000. Do you want to continue?`);
//     }
// };


//   export const weightVerifyBoth=(bulkWeightBefore,totalBeforeWeight,bulkWeightAfter,totalAfterWeight)=>{
//   let isTrue=""
//   const before= (bulkWeightBefore - totalBeforeWeight).toFixed(3); // Fix to 3 decimals
//   const after= (bulkWeightAfter - totalAfterWeight).toFixed(3);
//   // Convert `before` back to a number for comparison
//   const diffValue1 = parseFloat(before);
//   const diffValue2=parseFloat(after)

//   if (
//     !(
//       (diffValue1>= 0.000 &&diffValue1 <= 0.100) || 
//       (diffValue1>= -0.100 && diffValue1 <= -0.000)
//     )
//   ) {
//     isTrue=window.confirm(`Difference ${diffValue1} Verify failed on Before weight difference. Do you want to continue?`)
//     return isTrue
//   }

//   if (
//     !(
//       (diffValue2>= 0.000 &&diffValue2<= 0.100) || 
//       (diffValue2>= -0.100 && diffValue2<= -0.000)
//     )
//   ) {
//      isTrue=window.confirm(`Difference ${diffValue2} Verify failed on After weight difference. Do you want to continue?`)
//      return isTrue
//   }

//   else{
   
//     alert(`Verify Success on Both weight difference`)
//    }
// }




import axios from "axios"
import {REACT_APP_BACKEND_SERVER_URL} from "../config/index"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
 
 export const formatWeight = (value) => {
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    value === "null"
  ) {
    return "0.000";
  }

  const num = Number(value);
  return Number.isFinite(num) ? num.toFixed(3) : "0.000";
};

 // Id Modification like PL1TSWS000122 to TSWS000122 
 export const cleanPlainProduct=(productNumber)=>{
  
   return String(productNumber).trim().replace(/^PL\d+/, "");
}


export const transform_text = (num) => {
  if (num === undefined || num === null  ) return "";
  // Force convert to string always
  const str = String(num);
  if (str === "null" || str.startsWith("null__")) return "-";
  // If "__" not found, return whole string
  if (!str.includes("__")) return str;
  return str.split("__")[0];
};
 
export const handleWeight = () => {
  return new Promise((resolve, reject) => {
    try {
      const ws = new WebSocket("wss://wss1_ibacus.octosignals.com/ws/stream");

      ws.onopen = () => console.log("WS Connected");

      ws.onmessage = (event) => {
        const data = JSON.parse(event.data);
        console.log("WS DATA:", data.weight);
        resolve(data.weight);   // return weight here
        ws.close();             // close after receiving
      };

      ws.onerror = () => {
        reject("Weight machine not connected");
      };

    } catch (err) {
      reject("WS error");
    }
  });
};

// The WebSocket connection and handleWeight function were moved to client/src/services/webSocket.js
// Components needing real-time weight data should use the subscribeWeight function from that service.
// Example: import { subscribeWeight } from '../../services/webSocket';
 
 
  
  export const weightVerify = (value, weight1, weight2) => {
    // Check for the initial invalid condition
    if (!weight1 || !weight2 || isNaN(weight1) || isNaN(weight2)) {
          alert("Please Enter the Value")
        return;
    }
 
    // Convert to number if they are strings
    weight1 = parseFloat(weight1);
    weight2 = parseFloat(weight2);
 
    // Calculate weight difference
    const weight = (weight1 - weight2).toFixed(3);
    const diffValue = parseFloat(weight);
 
    // Check if the difference is positive within range
    if (diffValue >= 0.000 && diffValue <= 0.100) {
        alert(`Verify Success on ${value} weight difference`);
    }
    // Check if the difference is negative within range
    else if (diffValue < 0.000 && diffValue >= -0.100) {
        alert(`Verify Success on ${value} weight difference`);
    }
    // Check if the difference is greater than positive range
    else if (diffValue > 0.100) {
        window.confirm(`Difference ${diffValue} exceeds the upper limit. Verify failed on ${value} weight difference. Correct Range >= 0.000 to <= 0.100. Do you want to continue?`);
    }
    // All other cases (negative difference exceeds range)
    else {
        window.confirm(`Difference ${diffValue} is below the lower limit. Verify failed on ${value} weight difference. Correct Range -0.100 to <= 0.000. Do you want to continue?`);
    }
};
 
 
  export const weightVerifyBoth=(bulkWeightBefore,totalBeforeWeight,bulkWeightAfter,totalAfterWeight)=>{
  let isTrue=true
  const before= (bulkWeightBefore - totalBeforeWeight).toFixed(3); // Fix to 3 decimals
  const after= (bulkWeightAfter - totalAfterWeight).toFixed(3);
  // Convert `before` back to a number for comparison
  const diffValue1 = parseFloat(before);
  const diffValue2=parseFloat(after)
 
  if (
    !(
      (diffValue1>= 0.000 &&diffValue1 <= 0.100) ||
      (diffValue1>= -0.100 && diffValue1 <= -0.000)
    )
  ) {
    isTrue=window.confirm(`Difference ${diffValue1} Verify failed on Before weight difference. Do you want to continue?`)
    return isTrue
  }
 
  if (
    !(
      (diffValue2>= 0.000 &&diffValue2<= 0.100) ||
      (diffValue2>= -0.100 && diffValue2<= -0.000)
    )
  ) {
     isTrue=window.confirm(`Difference ${diffValue2} Verify failed on After weight difference. Do you want to continue?`)
     return isTrue
  }
 
  else{
    alert(`Verify Success on Both weight difference`)
    return isTrue
   }
}
